import {makeStyles} from '@material-ui/core';
import {HEADER_HEIGHT, DRAWER_WIDTH} from '../../../Dashboard/DashboardLayout/components/AppHeader/styles';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1.5rem',
      paddingBottom: '3rem'
    },
    noContentContainer: {
      textAlign: 'center',
      marginTop: '8rem',
    },
    noLabel: {
      fontSize: '1.5rem',
      opacity: '0.2',
    },
    casesContainer: {
      position: 'relative',
    },
    addCaseButton: {
      textTransform: 'capitalize',
    },
    headerContainer: {
      position: 'fixed',
      top: HEADER_HEIGHT,
      left: DRAWER_WIDTH,
      right: 0,
      zIndex: theme.zIndex.appBar - 1,
      backgroundColor: '#fff',
    },
    tabsContainer: {
      paddingTop: '15px',
    },
    actionButtonsContainer: {
      position: 'fixed',
      marginTop: '-50px',
      right: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    tabPanelContainer: {
      marginTop: '60px',
    },
  };
});
